// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_mobile_menu_box__HaU9U {
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 80px;
    display: block;
    position: fixed !important;
    background-color: #7B8073;
    border-bottom: 3px solid #ADB2A1;
}

.menu_mobile_menu_box__HaU9U div {
    direction: rtl;
    float: right !important;
}

.menu_mobile_menu_box__HaU9U h1 {
    margin: 0%;
    font-size: 15px;
    margin-top: 33px;
    color: #223300;
}
.menu_mobile_menu_box__HaU9U img {
    width: 30px;
    float: left;
    height: 30px;
    margin-top: 25px;
    margin-left: 36px;
}

.menu_desktop_menu_box__\\+z4ic {
    display: none;
}

@media (min-width: 1200px) {
    .menu_mobile_menu_box__HaU9U {
        display: none;
    }

    .menu_desktop_menu_box__\\+z4ic {
        top: 0;
        left: 0;
        z-index: 2;
        height: 110px;
        display: block;
        position: fixed;
        background-color: #7B8073;
        border-bottom: 5px solid #ADB2A1;
    }
    .menu_desktop_menu_box__\\+z4ic div {
        height: 110px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
    .menu_desktop_menu_box__\\+z4ic p {
        margin: 37px;
        margin-top: 39px;
        font-size: 18px;
        cursor: pointer;
        color: #FFFFFF;
        -webkit-user-select: none;
                user-select: none;
        font-family: "Gothic";
    }

    .menu_desktop_menu_box__\\+z4ic img {
        width: 30px;
        height: 30px;
        margin: 10px;
        display: inline;
        transition: transform 0.3s;
    }
    .menu_desktop_menu_box__\\+z4ic img:hover {
        transform: translateY(-8px);
    }
    .menu_desktop_menu_box__\\+z4ic h1 {
        margin: 0;
        margin-left: 40px;
        font-size: 20px;
        color: #223300;
        font-family: "Gothic";
        float: left;
        text-align: left;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/menu.module.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,MAAM;QACN,OAAO;QACP,UAAU;QACV,aAAa;QACb,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,gCAAgC;IACpC;IACA;QACI,aAAa;QACb,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,cAAc;QACd,yBAAiB;gBAAjB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,0BAA0B;IAC9B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,SAAS;QACT,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,qBAAqB;QACrB,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".mobile_menu_box {\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 100;\r\n    width: 100%;\r\n    height: 80px;\r\n    display: block;\r\n    position: fixed !important;\r\n    background-color: #7B8073;\r\n    border-bottom: 3px solid #ADB2A1;\r\n}\r\n\r\n.mobile_menu_box div {\r\n    direction: rtl;\r\n    float: right !important;\r\n}\r\n\r\n.mobile_menu_box h1 {\r\n    margin: 0%;\r\n    font-size: 15px;\r\n    margin-top: 33px;\r\n    color: #223300;\r\n}\r\n.mobile_menu_box img {\r\n    width: 30px;\r\n    float: left;\r\n    height: 30px;\r\n    margin-top: 25px;\r\n    margin-left: 36px;\r\n}\r\n\r\n.desktop_menu_box {\r\n    display: none;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .mobile_menu_box {\r\n        display: none;\r\n    }\r\n\r\n    .desktop_menu_box {\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 2;\r\n        height: 110px;\r\n        display: block;\r\n        position: fixed;\r\n        background-color: #7B8073;\r\n        border-bottom: 5px solid #ADB2A1;\r\n    }\r\n    .desktop_menu_box div {\r\n        height: 110px;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .desktop_menu_box p {\r\n        margin: 37px;\r\n        margin-top: 39px;\r\n        font-size: 18px;\r\n        cursor: pointer;\r\n        color: #FFFFFF;\r\n        user-select: none;\r\n        font-family: \"Gothic\";\r\n    }\r\n\r\n    .desktop_menu_box img {\r\n        width: 30px;\r\n        height: 30px;\r\n        margin: 10px;\r\n        display: inline;\r\n        transition: transform 0.3s;\r\n    }\r\n    .desktop_menu_box img:hover {\r\n        transform: translateY(-8px);\r\n    }\r\n    .desktop_menu_box h1 {\r\n        margin: 0;\r\n        margin-left: 40px;\r\n        font-size: 20px;\r\n        color: #223300;\r\n        font-family: \"Gothic\";\r\n        float: left;\r\n        text-align: left;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile_menu_box": `menu_mobile_menu_box__HaU9U`,
	"desktop_menu_box": `menu_desktop_menu_box__+z4ic`
};
export default ___CSS_LOADER_EXPORT___;
